<template>
    <div class="notice-edit">
        <el-form ref="noticeForm" :rules="rules" :model="noticeInfo" size="mini" label-width="120px" class="notice-form">
            <el-form-item label="公告标题" prop="noticeTitle">
                <el-input v-model="noticeInfo.noticeTitle"></el-input>
            </el-form-item>
            <el-form-item label="接收人员"  prop="receiverNames"
                :rules="[
                { required: true, message: '请选择接收人员', trigger: 'change' },
                ]">
                <el-tooltip :disabled="!selectedUser.selectedUserNames" :content="selectedUser.selectedUserNames" effect="light" placement="top">
                    <el-input readonly v-model="selectedUser.selectedUserNames" @focus="chooseUser" ></el-input>
                </el-tooltip> 
            </el-form-item>
            <el-form-item label="公告内容" prop="noticeContent">
               <Editorbar v-model="comment.content" :isClear="isClear" @sendClick="handleNoticeSave"></Editorbar>
               <el-tooltip content="选择强制提醒则用户登录系统时会自动弹出当前公告消息" effect="light" placement="top">
                  <el-checkbox v-model="mandatoryReminder" style="float:right;margin-right:20px;margin-top:4px;">强制提醒</el-checkbox>
                </el-tooltip>
              </el-form-item>
            <!-- <el-form-item>
                <el-button type="primary" :loading="isSaveDone" @click="handleNoticeSave">保存</el-button>
            </el-form-item> -->
        </el-form>
        <el-dialog
            title="选择定时消息接收人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowUserOrg"
            append-to-body
          > 
            <UserOrg ref="userOrgExt" :multiple="true" :selectedUser="selectedUser" :canDrop="true"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowUserOrg = false">取 消</el-button>
                <el-button type="primary" @click="confirmClick">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { getNoticeDetail, saveNotice } from '@/data-model';
    import Editorbar from '@/components/WangEditor';
    import defaultCronjob from './defaultCronjob';
    import mixinsNav from '@/mixins/mixins-nav';
    import { cloneDeep } from 'lodash';

    export default {
        mixins: [ mixinsNav ],
        components: {
            Editorbar
        },
        data () {
            return {
                isSaveDone: false,
                isShowUserOrg: false,
                selectUsers: [],
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                imageUrl: '',
                imagePath: '',
                noticeInfo: {},
                mandatoryReminder: false,
                comment: {
                    content: '',
                    mainId: '',
                    supId: ''
                },
                isClear: false,
                loadTimer: '',
                cronjob: JSON.parse(JSON.stringify(defaultCronjob)),
                rules: {
                    noticeTitle: [
                        { required: true, message: '请输入任务名称', trigger: 'blur' },
                        { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
                    ],
                    remarks: [
                        { required: true, message: '请输入任务描述', trigger: 'blur' },
                        { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
                    ],
                    startAt: [
                        { required: true, message: '请输入执行时间', trigger: 'blur' }
                    ]
                }
            };
        },
        props: {
            notice: {
                type: Object
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            async _initPage () {
                let id = this.notice.id;
                if (id) {
                    this.noticeInfo = await getNoticeDetail(id);
                    this.comment.content = this.noticeInfo.noticeContent;
                    this.selectedUser.selectedUserIds = this.noticeInfo.receiverIds;
                    this.selectedUser.selectedUserNames = this.noticeInfo.receiverNames;
                } else {
                    this.noticeInfo = {
                        noticeTitle: '',
                        receiverIds: '',
                        receiverNames: '',
                        noticeContent: ''
                    };
                    this.selectedUser = {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    };
                }
            },
            // setContent (content, text) {
            //     this.comment.content = content;
            // },
            async handleNoticeSave (content, text) {
                // 延迟调用,解决组件的值赋不上的问题
                this.comment.content = content;
                setTimeout(() => {
                    // console.log(this.comment.content);
                    this.$refs['noticeForm'].validate(async (valid) => {
                        if (valid) {
                            let loading = this.$loading({
                                lock: true,
                                text: 'Loading',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0,0,0,0.7)'
                            });
                            this.isSaveDone = true;
                            let param = cloneDeep(this.noticeInfo);
                            param.noticeContent = this.comment.content;
                            if (this.mandatoryReminder) {
                                param.mandatoryReminder = 1;
                            } else {
                                param.mandatoryReminder = 0;
                            }
                            await saveNotice(param);
                            loading.close();
                            this.$emit('closeDialog');
                        } else {
                            return false;
                        }
                    });
                }, 500);
            },
            handleCancel () {
                this.$emit('closeDialog');
            },
            confirmClick () {
                this.$refs.userOrgExt.setChoosedUser();
                this.selectUsers = [];
                this.noticeInfo.receiverIds = this.selectedUser.selectedUserIds;
                this.noticeInfo.receiverNames = this.selectedUser.selectedUserNames;
                this.isShowUserOrg = false;
            },
            chooseUser () {
                setTimeout(() => { // 初始化
                    this.$refs.userOrgExt._initPage();
                }, 0);
                this.isShowUserOrg = true;
            }
        }
    };
</script>

<style lang="less">
    .notice-edit {
        width: 100%;
        margin-top: 15px;
        .notice-form {
            width: 95%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/application/Notice/NoticeEdit/NoticeEdit.vue